import React from 'react'

const occupationContext = React.createContext({});

export { occupationContext }
